import { render, staticRenderFns } from "./CategoryHeightSelector.vue?vue&type=template&id=1c6f5d5d"
import script from "./CategoryHeightSelector.vue?vue&type=script&lang=js"
export * from "./CategoryHeightSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports